export default __webpack_public_path__ + "imgs/coenavi_OL-01.52abb84c.png";